import { render, staticRenderFns } from "./FIBToggle.vue?vue&type=template&id=07496f9d&scoped=true&"
import script from "./FIBToggle.vue?vue&type=script&lang=js&"
export * from "./FIBToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07496f9d",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QToggle});
